import { AbstractPerformanceRequirementNote } from './abstract-performance-requirement-note.model';

export class AttendancePerformanceRequirementNote extends AbstractPerformanceRequirementNote {
	current_consecutive_missed_days: number;
	currently_truant: boolean;
	total_period_days_attended: number;
	total_period_days_to_date: number;
}
